// @ts-ignore
import { GandalfArray } from 'gandalf';
// @ts-ignore
import { GandalfConstantDecorator } from 'gandalf';
// @ts-ignore
import { GandalfLabel } from 'gandalf';
// @ts-ignore
import { GandalfModel } from 'gandalf';
// @ts-ignore
import { GandalfModelBase } from 'gandalf';
// @ts-ignore
import { GandalfProperty } from 'gandalf';
// @ts-ignore
import { GandalfSubRequestLabel } from 'gandalf';
// @ts-ignore
import { GandalfValidator } from 'gandalf';
// @ts-ignore
import * as constants from '../constants';


// @ts-ignore
import { UpdateExternalProviderRequest } from './update-external-provider-request';

/** See com.rev360.pms.api.controller.patient.provider.UpdatePatientProviderRequest */
/* istanbul ignore next */
@GandalfModel
export class UpdatePatientProviderRequest extends GandalfModelBase {

	@GandalfValidator({ notNull: { message: 'Provider is required' } })
	@GandalfProperty({ designType: UpdateExternalProviderRequest, isRequired: true })
	externalProvider!: UpdateExternalProviderRequest;

	@GandalfValidator({ notNull: { message: 'Person Provider is required' } })
	@GandalfProperty({ designType: Number, isRequired: true })
	personProviderId!: number;

	@GandalfValidator({ notNull: { message: 'Provider Role is required' } })
	@GandalfProperty({ designType: Number, isRequired: true })
	providerRoleId!: number;

}
